import { BaseService } from './base.service';
import { IMedication } from '@/types/medication';

export class MemberMedicationService extends BaseService {
  constructor() {
    super('/medications');
  }

  async getAllForMember(memberId: string): Promise<{ data: IMedication[] }> {
    const pagination = {
      pageSize: 20,
    }
    return this.post(`/${memberId}/getAll`, { pagination });
  }

  async createForMember(memberId: string, data: IMedication | IMedication[]): Promise<IMedication[]> {
    // If data is an array, wrap in { medications: [...] } as backend expects
    if (Array.isArray(data)) {
      return this.post(`/${memberId}`, { medications: data });
    }
    return this.post(`/${memberId}`, data);
  }

  async updateForMember(memberId: string, medicationId: string, data: IMedication): Promise<IMedication[]> {
    return this.put(`/${memberId}/${medicationId}`, data);
  }

  async deleteForMember(memberId: string, medicationId: string): Promise<IMedication[]> {
    return this.delete(`/${memberId}/${medicationId}`);
  }
}

export const memberMedicationService = new MemberMedicationService();
